(() => {
  if (window.pfxCarouselLoaded) return;
  window.pfxCarouselLoaded = true;
  const instances = new Map();
  function init(root = document) {
    root.querySelectorAll('[data-pfx-carousel]').forEach(gallery => {
      if (instances.has(gallery)) return;
      const slides = [...gallery.querySelectorAll('[data-pfx-slide]')];
      const thumbs = [...gallery.querySelectorAll('[data-pfx-thumb]')];
      const display = gallery.querySelector('.gallery-display');
      const pause = gallery.querySelector('[data-pfx-pause]');
      let index = 0, timer, paused = false, hovering = false, focused = false, startX = null;
      const stop = () => clearInterval(timer);
      const show = n => {
        if (!slides.length) return;
        index = (n + slides.length) % slides.length;
        slides.forEach((slide, i) => {
          slide.classList.toggle('active', i === index);
          slide.setAttribute('aria-hidden', String(i !== index));
          slide.inert = i !== index;
        });
        thumbs.forEach((thumb, i) => thumb.setAttribute('aria-pressed', String(i === index)));
      };
      const play = () => {
        stop();
        if (gallery.dataset.autoplay !== 'true' || slides.length < 2 || paused || hovering || focused || document.hidden || window.Shopify?.designMode || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        timer = setInterval(() => show(index + 1), Number(gallery.dataset.interval) * 1000);
      };
      const move = n => { show(n); play(); };
      gallery.querySelector('[data-pfx-prev]')?.addEventListener('click', () => move(index - 1));
      gallery.querySelector('[data-pfx-next]')?.addEventListener('click', () => move(index + 1));
      thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => move(i)));
      display.addEventListener('keydown', event => {
        if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault();
        move(event.key === 'Home' ? 0 : event.key === 'End' ? slides.length - 1 : index + (event.key === 'ArrowRight' ? 1 : -1));
      });
      display.addEventListener('touchstart', event => { startX = event.touches[0].clientX; }, {passive:true});
      display.addEventListener('touchend', event => {
        if (startX === null) return;
        const dx = event.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) move(index + (dx < 0 ? 1 : -1));
        startX = null;
      }, {passive:true});
      display.addEventListener('touchcancel', () => { startX = null; });
      gallery.addEventListener('mouseenter', () => { hovering = true; stop(); });
      gallery.addEventListener('mouseleave', () => { hovering = false; play(); });
      gallery.addEventListener('focusin', () => { focused = true; stop(); });
      gallery.addEventListener('focusout', event => { if (!gallery.contains(event.relatedTarget)) { focused = false; play(); } });
      pause?.addEventListener('click', () => {
        paused = !paused;
        pause.textContent = paused ? 'Reanudar carrusel' : 'Pausar carrusel';
        pause.setAttribute('aria-pressed', String(paused)); play();
      });
      instances.set(gallery, {show, stop, play, slides});
      show(0); play();
    });
  }
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [gallery, api] of instances) if (event.target.contains(gallery)) { api.stop(); instances.delete(gallery); }
  });
  document.addEventListener('shopify:block:select', event => {
    for (const api of instances.values()) {
      const index = api.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
      if (index >= 0) { api.stop(); api.show(index); }
    }
  });
  document.addEventListener('visibilitychange', () => instances.forEach(api => api.play()));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
})();
